/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProximityZone } from './ProximityZone';
import {
    ProximityZoneFromJSON,
    ProximityZoneFromJSONTyped,
    ProximityZoneToJSON,
    ProximityZoneToJSONTyped,
} from './ProximityZone';

/**
 * Since a single logical zone violation event can end up triggering many individual zone violation events to the backend we group events that happened close in time to each other between the same vehicle and stationary unit into a single higher level zone violation incident.
 * 
 * Stationary unit zone violation events are aggregated into zone violation incidents in a background worker.
 * @export
 * @interface StationaryUnitZoneViolationIncident
 */
export interface StationaryUnitZoneViolationIncident {
    /**
     * Unique ID for this incident.
     * @type {string}
     * @memberof StationaryUnitZoneViolationIncident
     */
    id: string;
    /**
     * Time at which the zone violation incident started.
     * @type {Date}
     * @memberof StationaryUnitZoneViolationIncident
     */
    startTime: Date;
    /**
     * Time at which the zone violation incident ended.
     * @type {Date}
     * @memberof StationaryUnitZoneViolationIncident
     */
    stopTime: Date;
    /**
     * Vehicle that triggered this incident.
     * @type {string}
     * @memberof StationaryUnitZoneViolationIncident
     */
    vehicleId: string;
    /**
     * Stationary unit that triggered this incident.
     * @type {string}
     * @memberof StationaryUnitZoneViolationIncident
     */
    stationaryUnitId: string;
    /**
     * User that was logged in at the time the incident occurred, if any.
     * @type {string}
     * @memberof StationaryUnitZoneViolationIncident
     */
    userId?: string | null;
    /**
     * Minimum distance between the two devices in centimeters.
     * @type {number}
     * @memberof StationaryUnitZoneViolationIncident
     */
    minimumDistanceCm: number;
    /**
     * Closest ELOshield zone which was violated during the incident.
     * @type {ProximityZone}
     * @memberof StationaryUnitZoneViolationIncident
     */
    triggeredZone: ProximityZone;
}



/**
 * Check if a given object implements the StationaryUnitZoneViolationIncident interface.
 */
export function instanceOfStationaryUnitZoneViolationIncident(value: object): value is StationaryUnitZoneViolationIncident {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('stopTime' in value) || value['stopTime'] === undefined) return false;
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    if (!('stationaryUnitId' in value) || value['stationaryUnitId'] === undefined) return false;
    if (!('minimumDistanceCm' in value) || value['minimumDistanceCm'] === undefined) return false;
    if (!('triggeredZone' in value) || value['triggeredZone'] === undefined) return false;
    return true;
}

export function StationaryUnitZoneViolationIncidentFromJSON(json: any): StationaryUnitZoneViolationIncident {
    return StationaryUnitZoneViolationIncidentFromJSONTyped(json, false);
}

export function StationaryUnitZoneViolationIncidentFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationaryUnitZoneViolationIncident {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'startTime': (new Date(json['startTime'])),
        'stopTime': (new Date(json['stopTime'])),
        'vehicleId': json['vehicleId'],
        'stationaryUnitId': json['stationaryUnitId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'minimumDistanceCm': json['minimumDistanceCm'],
        'triggeredZone': ProximityZoneFromJSON(json['triggeredZone']),
    };
}

export function StationaryUnitZoneViolationIncidentToJSON(json: any): StationaryUnitZoneViolationIncident {
    return StationaryUnitZoneViolationIncidentToJSONTyped(json, false);
}

export function StationaryUnitZoneViolationIncidentToJSONTyped(value?: StationaryUnitZoneViolationIncident | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'startTime': value['startTime'].toISOString(),
        'stopTime': value['stopTime'].toISOString(),
        'vehicleId': value['vehicleId'],
        'stationaryUnitId': value['stationaryUnitId'],
        'userId': value['userId'],
        'minimumDistanceCm': value['minimumDistanceCm'],
        'triggeredZone': ProximityZoneToJSON(value['triggeredZone']),
    };
}

